import { ReactElement, ReactNode } from 'react'
import CloseIcon from '@mui/icons-material/Close'
import { Box, IconButton, Tooltip } from '@mui/material'
import { PanelHeader } from '@ui2/structure'

interface Props {
  title: ReactNode
  /** Shows a close button (deselecting the element) when given. */
  onClose?: () => void
}

/**
 * Header of the comment / table / image card forms in the drawer: the title and, where the form
 * can be closed, a close button. Sticks to the top while the form scrolls.
 */
const PlanElementFormHeader = ({ title, onClose }: Props): ReactElement => (
  <Box sx={{ position: 'sticky', top: 0, zIndex: 1, bgcolor: 'background.paper' }}>
    <PanelHeader
      title={title}
      action={
        onClose && (
          <Tooltip title="Schließen (Esc)">
            <IconButton size="small" onClick={onClose} data-cy="plan-element-form-close">
              <CloseIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        )
      }
    />
  </Box>
)

export default PlanElementFormHeader
